// extracted by mini-css-extract-plugin
export default {"subject":"SubjectGroup_subject__2+DEv","subjectTitle":"SubjectGroup_subjectTitle__hcJhO","themes":"SubjectGroup_themes__AYLgi"};